import { useState } from "react";
import { Button, Box, Modal, Fade, Stack, TextField, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
// ----------------------------------------------------------------------
const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalPaper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #fff',
        boxShadow: '0px 0px 4px #0000001A',
        padding: '4rem',
        minWidth: '300px',
        borderRadius: '4px',
        textAlign: 'center',
    },
    outlineButton: {
        color: '#85888A',
        fontSize: '14px',
        border: '1px solid #DEDEDE',
        borderRadius: '4px',
        fontWeight: 'normal',
        marginRight: '10px',
        padding: '0.5rem 1.5rem'
    },
    containedButton: {
        color: '#fff',
        fontSize: '14px',
        border: '1px solid #F45E29',
        borderRadius: '4px',
        fontWeight: 'normal',
        padding: '0.5rem 1.5rem'
    }
}));

export default function DeleteReportDialog(props) {
    const classes = useStyles();
    let { openPoup, handleDeleteReportPopup, handleSubmitDeleteReport } = props
  
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal-root"
            open={openPoup}
            closeAfterTransition
            >
            <Fade in={openPoup}>
            <Box  className="modal-paper modal-box modal-sm" id="transition-modal-title">
                <Box className="modal-content-simple">
                <Typography variant="subtitle1" className="modal-heading-title-simple">Are you sure, you want to delete this report ?</Typography>
                <Box className="modal-footer-simple">
                    <Button onClick={() => handleDeleteReportPopup('cancel')} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                    <Button onClick={handleSubmitDeleteReport} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
                </Box>
                </Box>
            </Box>
            </Fade>
        </Modal>
    )
}
